import { getState } from '~src/state';
import { displayImageManager } from '~src/sidebar/index';

export const addImageTagToCache = (imageItemId, tagsId) => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');
  const imageItem = window.editorConfig.sidebarImages[currentTag].items.find(
    (item) => item.objectId === imageItemId
  );

  if (tagsId) {
    tagsId.forEach((id) => {
      const tagItem = window.editorConfig.sidebarTags.items.find(
        (item) => item.objectId === id
      );
      imageItem.tags.push(tagItem);
    });
  }

  // imageItem.tags = imageItem.tags.push(tag => tag.objectId !== tagId);

  displayImageManager(imageItemId);
};
